.media {
  position: relative;
  margin: 0;
  overflow: hidden;
  border-radius: var(--radius-lg);
  background: var(--surface-dark);
  box-shadow: var(--shadow-lg);
}
.video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/* What the clip shows, as a chip on the footage rather than a caption under it. */
.caption {
  position: absolute;
  left: var(--sp-4);
  bottom: var(--sp-4);
  max-width: calc(100% - 5rem);
  padding: var(--sp-2) var(--sp-3);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: var(--radius);
  background: rgba(8, 13, 19, 0.72);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  color: #f5f7fa;
  font-size: var(--fs-sm);
  font-weight: 500;
}
.toggle {
  position: absolute;
  right: var(--sp-4);
  bottom: var(--sp-4);
  display: inline-grid;
  place-items: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  background: rgba(16, 20, 25, 0.6);
  color: #f5f7fa;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}
.toggle:hover {
  background: rgba(16, 20, 25, 0.85);
}
.playIcon {
  width: 0;
  height: 0;
  margin-left: 2px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 10px solid currentColor;
}
.pauseIcon {
  width: 11px;
  height: 12px;
  border-inline: 3px solid currentColor;
}
